import { IconName } from '@subframe/core';
import { Button, Checkbox, CheckboxGroup, Select } from 'subframe/index';
import { truncateAtLength } from 'utils/formatString';

export interface MultiSelectDropdownProps {
  disabled?: boolean;
  options: { label: string; value: string }[];
  emptyLabel: string;
  listHeader: string;
  selected: string[];
  setSelected: (o: string[]) => void;

  selectAdditionalClassNames?: string;
  selectTruncationLength?: number;
  iconName?: IconName;
  variant?: 'filled' | 'outline';
}

export default function MultiSelectDropdown(
  props: MultiSelectDropdownProps,
): JSX.Element {
  return (
    <Select
      className={`h-auto flex-none ${
        props.selectAdditionalClassNames || 'w-44'
      }${props.disabled ? ' opacity-50' : ''}`}
      icon={props.iconName ? props.iconName : null}
      disabled={props.disabled}
      variant={props.variant || 'outline'}
      placeholder={truncateAtLength(
        props.selected.length > 0
          ? props.selected
              .map((s) => props.options.find((o) => o.value == s)?.label || '')
              .filter((s) => s.trim() != '')
              .join(', ')
          : props.emptyLabel,
        props.selectTruncationLength || 16,
      )}
    >
      <div className="flex w-full items-center gap-2 pt-1 pr-1 pb-1 pl-3">
        <CheckboxGroup label={` ${props.listHeader}`} helpText="">
          {props.options.map((option) => (
            <Checkbox
              checked={props.selected.includes(option.value)}
              key={option.value}
              label={option.label}
              value={option.value}
              onClick={() => {
                if (props.selected.includes(option.value)) {
                  props.setSelected(
                    props.selected.filter((s) => s !== option.value),
                  );
                } else {
                  props.setSelected([...props.selected, option.value]);
                }
              }}
            />
          ))}
        </CheckboxGroup>
      </div>
      <div className="flex w-full flex-col items-start pt-0.5 pb-0.5">
        <div className="flex h-px w-full flex-none flex-col items-center gap-2 bg-neutral-300" />
      </div>
      <Button
        className="h-8 w-full flex-none justify-start"
        variant="neutral-tertiary"
        onClick={(event) => {
          event.preventDefault();
          props.setSelected([]);
        }}
      >
        Clear Selection
      </Button>
    </Select>
  );
}
